import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { useUI } from '../../context/UIContext';

/**
 * A wrapper around MUI's Tooltip that automatically disables itself on mobile devices.
 * This prevents tooltip issues on touch screens. It disables hover, focus, and touch listeners.
 */
const ConditionalTooltip = ({ children, ...props }) => {
  const { isMobile } = useUI();

  return (
    <Tooltip {...props} disableHoverListener={isMobile} disableFocusListener={isMobile} disableTouchListener={isMobile}>
      {children}
    </Tooltip>
  );
};

ConditionalTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConditionalTooltip;